import { Card, Row, Col, Divider, Button, Space, Flex, Form } from "antd";
import { useTranslation } from "react-i18next";
import { FormInputNumber, } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import FormSwitch from "components/form/FormProvide/FormSwitch";
import { useForm } from "antd/es/form/Form";
import { useEffect } from "react";

const BesmartCondition = ({
  initialValues = {},
  onSubmitGradeConfig = () => { }
}) => {
  const { t } = useTranslation();
  const [form] = useForm();

  useEffect(() => {
    if (Object.keys(initialValues).length > 0) {
      setTimeout(() => {
        form.setFieldsValue(initialValues);
      }, 0);

    }
  }, [initialValues, form]);

  return (
    <FormAntd
      form={form}
      initialValues={{
        percentageOfLate: 0,
        gradeANoMoreLateThan: 0,
        gradeBNoMoreLateThan: 0,
        gradeCNoMoreLateThan: 0,
        gradeDNoMoreLateThan: 0,
        gradeFNoMoreLateThan: 0,

        percentageOfAbsences: 0,
        gradeANoMoreAbsencesThan: 0,
        gradeBNoMoreAbsencesThan: 0,
        gradeCNoMoreAbsencesThan: 0,
        gradeDNoMoreAbsencesThan: 0,
        gradeFNoMoreAbsencesThan: 0,

        percentageOfLeaves: 0,
        gradeANoMoreLeavesThan: 0,
        gradeBNoMoreLeavesThan: 0,
        gradeCNoMoreLeavesThan: 0,
        gradeDNoMoreLeavesThan: 0,
        gradeFNoMoreLeavesThan: 0,
        ...initialValues
      }}
      onFinish={onSubmitGradeConfig}
    >
      <Form.Item shouldUpdate={(prev, cur) =>
        prev.gradeByNumberOfLate !== cur.gradeByNumberOfLate ||
        prev.gradeByNumberOfAbsences !== cur.gradeByNumberOfAbsences ||
        prev.gradeByNumberOfLeaves !== cur.gradeByNumberOfLeaves
      }>
        {({ getFieldValue, setFieldValue, resetFields }) => {
          return (
            <Flex vertical style={{ gap: "24px" }}>
              <Card style={{ backgroundColor: "white", width: "100%", border: "1px solid #EAECF0", padding: "16px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                  <div>
                    <h3 >{t('time_Condition.number_of_timelate')}</h3>
                    <p>
                      {t('time_Condition_Detail.number_of_timelate_detail')}
                    </p>
                  </div>
                  <FormSwitch
                    name="gradeByNumberOfLate"
                    onChange={(checked) => {
                      if (!checked) {
                        form.setFieldsValue({
                          percentageOfLate: 0,
                          gradeANoMoreLateThan: 0,
                          gradeBNoMoreLateThan: 0,
                          gradeCNoMoreLateThan: 0,
                          gradeDNoMoreLateThan: 0,
                          gradeFNoMoreLateThan: 0,
                        });
                      }
                    }} />
                </div>
                {getFieldValue("gradeByNumberOfLate") && (
                  <>
                    <Divider />
                    <Row gutter={[24, 24]}>
                      <Col span={7}>
                        <FormInputNumber
                          name="percentageOfLate"
                          label={t('grade_late.grade_percent')}
                          size="large"
                          placeholder={false}
                          controls={false}
                          suffix={"%"}
                          precision={2}
                        />
                      </Col>

                      <Col span={17} />

                      <Col span={8}>
                        <FormInputNumber
                          name="gradeANoMoreLateThan"
                          label={t("grade_late.grade_A")}
                          size="large"
                          placeholder={false}
                          controls={false}
                          required
                          layoutType="horizontal"
                          width="6vw"
                          suffixText={t('time.header')}
                          precision={0}
                        />
                      </Col>

                      <Col span={8}>
                        <FormInputNumber
                          name="gradeBNoMoreLateThan"
                          label={t("grade_late.grade_B")}
                          size="large"
                          placeholder={false}
                          controls={false}
                          required
                          layoutType="horizontal"
                          width="6vw"
                          suffixText={t('time.header')}
                          precision={0}
                        />
                      </Col>

                      <Col span={8}>
                        <FormInputNumber
                          name="gradeCNoMoreLateThan"
                          label={t("grade_late.grade_C")}
                          size="large"
                          placeholder={false}
                          controls={false}
                          required
                          layoutType="horizontal"
                          width="6vw"
                          suffixText={t('time.header')}
                          precision={0}
                        />
                      </Col>

                      <Col span={8}>
                        <FormInputNumber
                          name="gradeDNoMoreLateThan"
                          label={t("grade_late.grade_D")}
                          size="large"
                          placeholder={false}
                          controls={false}
                          required
                          layoutType="horizontal"
                          width="6vw"
                          suffixText={t('time.header')}
                          precision={0}
                        />
                      </Col>

                      <Col span={8}>
                        <FormInputNumber
                          name="gradeFNoMoreLateThan"
                          label={t("grade_late.grade_F")}
                          size="large"
                          placeholder={false}
                          controls={false}
                          required
                          layoutType="horizontal"
                          width="6vw"
                          suffixText={t('time.header')}
                          precision={0}
                        />
                      </Col>
                    </Row>
                  </>
                )}
              </Card>

              <Card style={{ backgroundColor: "white", width: "100%", border: "1px solid #EAECF0", padding: "16px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                  <div>
                    <h3 >{t('time_Condition.number_of_absences')}</h3>
                    <p>
                      {t('time_Condition_Detail.number_of_absences_detail')}
                    </p>
                  </div>
                  <FormSwitch
                    name="gradeByNumberOfAbsences"
                    onChange={(checked) => {
                      if (!checked) {
                        form.setFieldsValue({
                          percentageOfAbsences: 0,
                          gradeANoMoreAbsencesThan: 0,
                          gradeBNoMoreAbsencesThan: 0,
                          gradeCNoMoreAbsencesThan: 0,
                          gradeDNoMoreAbsencesThan: 0,
                          gradeFNoMoreAbsencesThan: 0,
                        });
                      }
                    }}
                  />
                </div>
                {getFieldValue("gradeByNumberOfAbsences") && (
                  <>
                    <Divider />
                    <Row gutter={[24, 24]}>
                      <Col span={7}>
                        <FormInputNumber
                          name="percentageOfAbsences"
                          label={t('grade_absenteeism.grade_percent')}
                          size="large"
                          placeholder={false}
                          controls={false}
                          suffix={"%"}
                          precision={2}
                        />
                      </Col>

                      <Col span={17} />

                      <Col span={8}>
                        <FormInputNumber
                          name="gradeANoMoreAbsencesThan"
                          label={t('grade_absenteeism.grade_A')}
                          size="large"
                          placeholder={false}
                          controls={false}
                          required
                          layoutType="horizontal"
                          width="6vw"
                          suffixText={t('time.header')}
                          precision={0}
                        />
                      </Col>

                      <Col span={8}>
                        <FormInputNumber
                          name="gradeBNoMoreAbsencesThan"
                          label={t("grade_absenteeism.grade_B")}
                          size="large"
                          placeholder={false}
                          controls={false}
                          required
                          layoutType="horizontal"
                          width="6vw"
                          suffixText={t('time.header')}
                          precision={0}
                        />
                      </Col>

                      <Col span={8}>
                        <FormInputNumber
                          name="gradeCNoMoreAbsencesThan"
                          label={t("grade_absenteeism.grade_C")}
                          size="large"
                          placeholder={false}
                          controls={false}
                          required
                          layoutType="horizontal"
                          width="6vw"
                          suffixText={t('time.header')}
                          precision={0}
                        />
                      </Col>

                      <Col span={8}>
                        <FormInputNumber
                          name="gradeDNoMoreAbsencesThan"
                          label={t("grade_absenteeism.grade_D")}
                          size="large"
                          placeholder={false}
                          controls={false}
                          required
                          layoutType="horizontal"
                          width="6vw"
                          suffixText={t('time.header')}
                          precision={0}
                        />
                      </Col>


                      <Col span={8}>
                        <FormInputNumber
                          name="gradeFNoMoreAbsencesThan"
                          label={t("grade_absenteeism.grade_F")}
                          size="large"
                          placeholder={false}
                          controls={false}
                          required
                          layoutType="horizontal"
                          width="6vw"
                          suffixText={t('time.header')}
                          precision={0}
                        />
                      </Col>
                    </Row>
                  </>
                )
                }
              </Card>

              <Card style={{ backgroundColor: "white", width: "100%", border: "1px solid #EAECF0", padding: "16px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                  <div>
                    <h3 >{t('time_Condition.number_of_taketime')}</h3>
                    <p>
                      {t('time_Condition_Detail.number_of_taketime_detail')}
                    </p>
                  </div>
                  <FormSwitch
                    name="gradeByNumberOfLeaves"
                    onChange={(checked) => {
                      if (!checked) {
                        form.setFieldsValue({
                          percentageOfLeaves: 0,
                          gradeANoMoreLeavesThan: 0,
                          gradeBNoMoreLeavesThan: 0,
                          gradeCNoMoreLeavesThan: 0,
                          gradeDNoMoreLeavesThan: 0,
                          gradeFNoMoreLeavesThan: 0,
                        });
                      }
                    }}
                  />
                </div>

                {getFieldValue("gradeByNumberOfLeaves") && (
                  <>
                    <Divider />
                    <Row gutter={[24, 24]}>
                      <Col span={7}>
                        <FormInputNumber
                          suffix="%"
                          style={{ width: '100%' }}
                          name="percentageOfLeaves"
                          label={t('grade_takeTime.grade_percent')}
                          size="large"
                          placeholder={false}
                          controls={false}
                          precision={2}
                        />
                      </Col>

                      <Col span={17} />

                      <Col span={8}>
                        <FormInputNumber
                          name="gradeANoMoreLeavesThan"
                          label={t('grade_taketime.grade_A')}
                          size="large"
                          placeholder={false}
                          controls={false}
                          required
                          layoutType="horizontal"
                          width="6vw"
                          suffixText={t('time.header')}
                          precision={0}
                        />
                      </Col>

                      <Col span={8}>
                        <FormInputNumber
                          name="gradeBNoMoreLeavesThan"
                          label={t("grade_taketime.grade_B")}
                          size="large"
                          placeholder={false}
                          controls={false}
                          required
                          layoutType="horizontal"
                          width="6vw"
                          suffixText={t('time.header')}
                          precision={0}
                        />
                      </Col>

                      <Col span={8}>
                        <FormInputNumber
                          name="gradeCNoMoreLeavesThan"
                          label={t("grade_taketime.grade_C")}
                          size="large"
                          placeholder={false}
                          controls={false}
                          required
                          layoutType="horizontal"
                          width="6vw"
                          suffixText={t('time.header')}
                          precision={0}
                        />
                      </Col>

                      <Col span={8}>
                        <FormInputNumber
                          name="gradeDNoMoreLeavesThan"
                          label={t("grade_taketime.grade_D")}
                          size="large"
                          placeholder={false}
                          controls={false}
                          required
                          layoutType="horizontal"
                          width="6vw"
                          suffixText={t('time.header')}
                          precision={0}
                        />
                      </Col>

                      <Col span={8}>
                        <FormInputNumber
                          name="gradeFNoMoreLeavesThan"
                          label={t("grade_taketime.grade_F")}
                          size="large"
                          placeholder={false}
                          controls={false}
                          required
                          layoutType="horizontal"
                          width="6vw"
                          suffixText={t('time.header')}
                          precision={0}
                        />
                      </Col>
                    </Row>
                  </>
                )}
              </Card>

              <Card style={{ backgroundColor: "white", width: "100%", border: "1px solid #EAECF0", padding: "16px" }}>
                <div>
                  <h3>{t('time_Condition.Grade_percentage_criteria')}</h3>
                  <p>
                    {t('time_Condition_Detail.Grade_percentage_criteria_detail')}
                  </p>
                </div>
                <Divider />
                <Row gutter={[24, 24]}>
                  <Col span={8}>
                    <FormInputNumber
                      name="gradeANotLessThan"
                      label={t('grade_minimum.grade_A')}
                      size="large"
                      placeholder={false}
                      controls={false}
                      required
                      layoutType="horizontal"
                      width="6vw"
                      suffixText="%"
                      precision={2}
                    />
                  </Col>

                  <Col span={8}>
                    <FormInputNumber
                      name="gradeBNotLessThan"
                      label={t("grade_minimum.grade_B")}
                      size="large"
                      placeholder={false}
                      controls={false}
                      required
                      layoutType="horizontal"
                      width="6vw"
                      suffixText="%"
                      precision={2}
                    />
                  </Col>

                  <Col span={8}>
                    <FormInputNumber
                      name="gradeCNotLessThan"
                      label={t("grade_minimum.grade_C")}
                      size="large"
                      placeholder={false}
                      controls={false}
                      required
                      layoutType="horizontal"
                      width="6vw"
                      suffixText="%"
                      precision={2}
                    />
                  </Col>

                  <Col span={8}>
                    <FormInputNumber
                      name="gradeDNotLessThan"
                      label={t("grade_minimum.grade_D")}
                      size="large"
                      placeholder={false}
                      controls={false}
                      required
                      layoutType="horizontal"
                      width="6vw"
                      suffixText="%"
                      precision={2}
                    />
                  </Col>

                  <Col span={8}>
                    <FormInputNumber
                      name="gradeFNotLessThan"
                      label={t("grade_minimum.grade_F")}
                      size="large"
                      placeholder={false}
                      controls={false}
                      required
                      layoutType="horizontal"
                      width="6vw"
                      suffixText="%"
                      precision={2}
                    />
                  </Col>
                </Row>

              </Card>
              <Row justify="end" >
                <Space size={12}>
                  <Button type="default" onClick={() => { resetFields() }} size="large" style={{ borderRadius: "8px" }}>
                    {t("common.cancel").toUpperCase()}
                  </Button>
                  <Button type="primary" htmlType="submit" size="large" style={{ borderRadius: "8px", backgroundColor: "var(--button-color)" }}>
                    {t("confirm").toUpperCase()}
                  </Button>
                </Space>
              </Row>
            </Flex>
          )
        }}
      </Form.Item >
    </FormAntd >
  );
};

export default BesmartCondition;
